module.exports = __webpack_public_path__ + "img/parquet.a02df06a.png";